/** Rótulos de papel de agente — compartilhado Hoje / Kanban. */
export function agentRoleLabel(kind?: string | null): string | null {
  if (!kind) return null;
  const k = kind.toLowerCase();
  if (k.includes('pause')) return 'pausada';
  if (k.includes('follow')) return 'follow-up';
  if (k.includes('campaign') || k.includes('campanha')) return 'campanha';
  if (k.includes('crm')) return 'crm';
  if (k.includes('recept')) return 'receptiva';
  return kind;
}

export function formatAgentChip(name?: string | null, kind?: string | null): string | null {
  if (!name) return null;
  const role = agentRoleLabel(kind);
  return role ? `${name} · ${role}` : name;
}

type AgentCapabilities = { capReceptive: boolean; capCampaign: boolean; capFollowup: boolean; capCrm: boolean };

/** Funções de um funcionário digital, na ordem das seções da tela Funcionários. */
export function agentCapabilityLabels(a: AgentCapabilities): string[] {
  const out: string[] = [];
  if (a.capReceptive) out.push('Atendimento');
  if (a.capCampaign) out.push('Campanha');
  if (a.capFollowup) out.push('Follow-up');
  if (a.capCrm) out.push('CRM');
  return out;
}

export function agentStatusLabel(isEnabled: boolean): string {
  return isEnabled ? 'Ativo' : 'Pausado';
}
